/* eslint-disable @typescript-eslint/no-explicit-any, func-names, no-underscore-dangle, prefer-rest-params, no-multi-assign */
let tiktokInitialized = false;

export function initTikTokPixel(): void {
  if (tiktokInitialized) {
    return;
  }

  const { hostname } = window.location;
  const isProd = hostname === 'webapp.everydoggy.com' || hostname === 'app.everydoggy.com';

  if (!isProd) {
    return;
  }

  if (typeof window.ttq === 'object') {
    tiktokInitialized = true;
    return;
  }

  (function (w: any, d: Document, t: string) {
    w.TiktokAnalyticsObject = t;
    const ttq = w[t] = w[t] || [];
    ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
    ];
    ttq.setAndDefer = function (obj: any, method: string) {
      obj[method] = function () {
        obj.push([method].concat([].slice.call(arguments)));
      };
    };
    for (let i = 0; i < ttq.methods.length; i += 1) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }
    ttq.instance = function (id: string) {
      const inst = ttq._i[id] || [];
      for (let i = 0; i < ttq.methods.length; i += 1) {
        ttq.setAndDefer(inst, ttq.methods[i]);
      }
      return inst;
    };
    ttq.load = function (id: string, options?: unknown) {
      const url = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {};
      ttq._i[id] = [];
      ttq._i[id]._u = url;
      ttq._t = ttq._t || {};
      ttq._t[id] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[id] = options || {};
      const script = d.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `${url}?sdkid=${id}&lib=${t}`;
      const firstScript = d.getElementsByTagName('script')[0];
      firstScript.parentNode?.insertBefore(script, firstScript);
    };

    ttq.load('CCVBPERC77U26HDI330G');
    ttq.page();
  }(window, document, 'ttq'));

  tiktokInitialized = true;
}
